import api from "./api";

export const sendMailVerify = (mailData) => api.post(`/email/verify`, mailData);